var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1752116130602,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1504,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M567.808 853.276444v56.888889h37.262222a56.888889 56.888889 0 0 1 0 113.777778H418.816a56.775111 56.775111 0 0 1-56.718222-56.888889c0-31.402667 25.372444-56.888889 56.718222-56.888889h35.498667v-56.888889c-161.507556-15.815111-311.694222-171.690667-340.593778-342.243555l113.550222 0.910222c29.752889 142.449778 143.758222 227.555556 283.761778 227.555556 140.117333 0 254.065778-85.105778 283.875555-227.555556l115.256889-0.910222c-28.842667 170.552889-180.792889 326.428444-342.357333 342.243555z m-56.775111-170.666666a227.328 227.328 0 0 1-227.043556-227.555556v-227.555555c0-125.667556 101.660444-227.555556 227.043556-227.555556a227.271111 227.271111 0 0 1 227.043555 227.555556v227.555555c0 125.667556-101.603556 227.555556-227.043555 227.555556z m113.550222-455.111111c0-62.805333-50.801778-113.777778-113.550222-113.777778a113.664 113.664 0 0 0-113.493333 113.777778v227.555555c0 62.862222 50.801778 113.777778 113.493333 113.777778a113.607111 113.607111 0 0 0 113.550222-113.777778v-227.555555z",
    fill: "#666666",
    "p-id": 1505
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.7843e2f20366f372fb4860145805ab8a.svg";
export { ForwardRef as ReactComponent };